window.LocalStorageActions =
{
    setItem: function (key, value) {
        localStorage.setItem(key, value);
    },

    getItem: function (key) {
        return localStorage.getItem(key);
    },

    removeItem: function (key) {
        localStorage.removeItem(key);
    },

    clearData: function () {
        localStorage.clear();
    }
}